import styles from '../../Item/styles.module.scss';
import { RootState } from '@/lib/store';
import { useDispatch, useSelector } from 'react-redux';
//Switch Variants
import dynamic from 'next/dynamic';
import { toggleOpenSidebar } from '@/lib/store/side-bar/actions';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import useMobileNavigationVariant from '@/hooks/theme/variants/useMobileNavigationVariant';

const NavbarButton = dynamic(() => import('../../Item/Button'), {
  ssr: true,
});

export default function MenuButton() {
  const dispatch = useDispatch();
  const open = useSelector((state: RootState) => state.sideBar.open);

  function openMenu() {
    dispatch(toggleOpenSidebar());
  }

  const version: string = useMobileNavigationVariant();

  switch (version?.toString()) {
    case SettingLayoutComponentId.NavbarV1.toString():
      return (
        <div className={styles.container}>
          <NavbarButton
            onClick={openMenu}
            disabled={open}
            active={open}
            icon="fas fa-bars"
            label="tab_menu"
          />
        </div>
      );

    case SettingLayoutComponentId.NavbarV2.toString():
      return (
        <div className={`${styles.container} ${styles['container--v2']}`}>
          <NavbarButton
            onClick={openMenu}
            disabled={open}
            active={open}
            icon="fas fa-bars"
            label="tab_menu"
          />
        </div>
      );

    default:
      return (
        <div className={styles.container}>
          <NavbarButton
            onClick={openMenu}
            disabled={open}
            active={open}
            icon="fas fa-bars"
            label="tab_menu"
          />
        </div>
      );
  }
}
